import { render, staticRenderFns } from "./OrgNumberField.vue?vue&type=template&id=3d7b851f&"
import script from "./OrgNumberField.vue?vue&type=script&lang=js&"
export * from "./OrgNumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports